import React, { ReactElement, FC } from "react";
import classNames from "classnames/dedupe";
import { Row, Column } from "../../Fundamentals/Grid";
import { Typography } from "../../Fundamentals/Typography";
import { Image, IImageData } from "../../Utility/MediaBuilder/Image";
import { CustomImageWrapper } from "../../Utility/CustomImageWrapper";

export interface ISimpleHeroBanner {
  title: string;
  description: string;
  brandLogo?: ReactElement;
  brandImage?: IImageData;
  customImage?: JSX.Element;
  classes?: {
    root?: string;
  };
}

const SimpleHeroBanner: FC<ISimpleHeroBanner> = ({
  title,
  description,
  brandLogo,
  brandImage,
  customImage,
  classes,
}) => {
  const rootClasses = classNames(
    "d-flex flex-column-reverse flex-md-row simple-hero-banner",
    classes?.root,
  );
  return (
    <Row
      classes={{
        root: rootClasses,
      }}
    >
      <Column
        xs={12}
        md={7}
        xl={8}
        classes={{
          root: "simple-hero-banner__description p-6 pb-7 p-md-7 px-lgm-10 d-flex flex-column flex-md-row align-items-md-center bg-color-blue text-color-white",
        }}
      >
        {brandLogo}
        <div className="d-flex flex-column">
          <Typography
            variant="h2-enriched"
            classes={{ root: "mb-4 mb-md-6" }}
            as="h2"
          >
            {title}
          </Typography>
          <Typography classes={{ root: "p-banner m-0" }}>
            {description}
          </Typography>
        </div>
      </Column>
      <Column
        xs={12}
        md={5}
        xl={4}
        classes={{
          root: "simple-hero-banner__media p-0",
        }}
      >
        {customImage ? (
          <CustomImageWrapper ratio="16x9">{customImage}</CustomImageWrapper>
        ) : (
          <Image src={brandImage?.src} ratio={brandImage?.ratio} />
        )}
      </Column>
    </Row>
  );
};

export default SimpleHeroBanner;
